




























import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';

import { REQUEST_TYPE } from '@/config';
import { BUTTON_COLORS } from '../../config';
import MenuNavigation from '../shared/menu-navigation.vue';

export default Vue.extend({
  name: 'TopListened',

  components: {
    MenuNavigation,
  },

  data: () => ({
    requestTypes: REQUEST_TYPE,
    buttonColors: BUTTON_COLORS,

    buttons: [
      {
        label: 'Several Years',
        color: BUTTON_COLORS.yellow,
        key: 'long_term',
        icon: 'mdi-calendar-multiple',
      },
      {
        label: 'Several Months',
        color: BUTTON_COLORS.orange,
        key: 'medium_term',
        icon: 'mdi-calendar-month',
      },
      {
        label: 'Several Weeks',
        color: BUTTON_COLORS.purple,
        key: 'short_term',
        icon: 'mdi-calendar-range',
      },
    ],
  }),

  computed: {
    ...mapGetters('data', [
      'getTimeRange',
    ]),
  },

  methods: {
    ...mapActions('data', [
      'changeSettingsTimeRange',
      'collectData',
    ]),

    selectOption(key: string) {
      if (key === this.getTimeRange) {
        this.changeSettingsTimeRange('');
      } else {
        this.changeSettingsTimeRange(key);
      }
    },

    back() {
      this.changeSettingsTimeRange('');
      this.$emit('select', REQUEST_TYPE.NONE);
    },

    map() {
      this.collectData();
      this.$router.push('/exploring');
    },
  },
});
